(function (module) {
    "use strict";

    module.service('skuCalculationService', ['synchronousEventsBus', 'mkrshCalculatorService', '$q',
        function(
            this: $TSFixMe,
            synchronousEventsBus: $TSFixMe,
            mkrshCalculatorService: $TSFixMe,
            $q: ng.IQService
        ) {
            var service = this;

            service.registerEvents = function () {


                synchronousEventsBus.$on('brandVolumeForecastChanged', function (e: $TSFixMe, args: $TSFixMe) {
                    if (args.forecast.parameters.forecastType.typeId == 'volume' && args.forecast.parameters.forecastMethod.methodId == 'mktsh') {
                        return service.calculateSkuVolumeThroughMkshr(args.brand, args.forecast.parameters);
                    }
                });

                synchronousEventsBus.$on('brandDotForecastChanged', function (e: $TSFixMe, args: $TSFixMe) {
                    if (args.forecast.parameters.forecastType.typeId == 'dot' && args.forecast.parameters.forecastMethod.methodId == 'mktsh') {
                        return service.calculateSkuDotThroughMkshr(args.brand, args.forecast.parameters);
                    }
                });

                synchronousEventsBus.$on('brandValueForecastChanged', function (e: $TSFixMe, args: $TSFixMe) {
                    if (args.forecast.parameters.forecastType.typeId == 'value' && args.forecast.parameters.forecastMethod.methodId == 'mktsh') {
                        return service.calculateSkuValueThroughMkshr(args.brand, args.forecast.parameters);
                    }
                });

                synchronousEventsBus.$on('skuVolumeForecastChanged', function (e: $TSFixMe, args: $TSFixMe) {
                    if (args.parameters.forecastType.typeId == 'volume' && args.parameters.forecastMethod.methodId == 'mktsh') {
                        return service.calculateSkuValueFromVolumeThroughPrice(args.brand, args.parameters);
                    }
                });

                synchronousEventsBus.$on('skuValueForecastChanged', function (e: $TSFixMe, args: $TSFixMe) {
                    if (args.parameters.forecastType.typeId == 'value' && args.parameters.forecastMethod.methodId == 'mktsh') {
                        return service.calculateSkuVolumeFromValueThroughPrice(args.brand, args.parameters);
                    }
                });

                synchronousEventsBus.$on('skuDotForecastChanged', function (e: $TSFixMe, args: $TSFixMe) {
                    if (args.parameters.forecastType.typeId == 'dot' && args.parameters.forecastMethod.methodId == 'mktsh') {
                        return $q.all([
                            service.calculateSkuValueFromDotTroughtPrice(args.brand, args.parameters),
                            service.calculateSkuVolumeFromDotTroughtDddFact(args.brand, args.parameters)
                        ]);
                    }
                });
            }
            service.skuSplitChanged = function (brand: $TSFixMe, parameters: $TSFixMe) {
                if (parameters.forecastType.typeId == 'volume') {
                    return service.calculateSkuVolumeThroughMkshr(brand, parameters);
                } else if (parameters.forecastType.typeId == 'value') {
                    return service.calculateSkuValueThroughMkshr(brand, parameters);
                } else if (parameters.forecastType.typeId == 'dot') {
                    return service.calculateSkuDotThroughMkshr(brand, parameters);
                }
            }

            service.skuPriceChanged = function (brand: $TSFixMe, parameters: $TSFixMe) {
                if (parameters.forecastType.typeId == 'volume') {
                    return service.calculateSkuValueFromVolumeThroughPrice(brand, parameters);
                } else if (parameters.forecastType.typeId == 'value') {
                    return service.calculateSkuVolumeFromValueThroughPrice(brand, parameters);
                } else if (parameters.forecastType.typeId == 'dot') {
                    return service.calculateSkuValueFromDotTroughtPrice(brand, parameters);
                }
            }

            service.calculateSkuVolumeThroughMkshr = function (brand: $TSFixMe, parameters: $TSFixMe) {

                
                if (_.some(brand.skus, function (sku: $TSFixMe) {

                    return angular.isUndefinedOrNull(sku.forecast.mkshr);
                })) {
                    return;
                }


                for (var i = 0; i < brand.skus.length; i++) {
                    var sku = brand.skus[i];


                    if (angular.isUndefinedOrNull(sku.forecast.volume))
                        sku.forecast.volume = {
                            pmForecast: [],
                            statisticalForecast: []
                        };

                    mkrshCalculatorService.multiplieByMksrh(
                        sku.forecast.mkshr,
                        brand.forecast.volume.pmForecast,
                        brand.forecast.volume.statisticalForecast,
                        sku.forecast.volume.pmForecast,
                        sku.forecast.volume.statisticalForecast);

                }
                return synchronousEventsBus.$broadcast('skuVolumeForecastChanged', { brand: brand, parameters: parameters });
            }

            service.calculateSkuValueThroughMkshr = function (brand: $TSFixMe, parameters: $TSFixMe) {
                
                if (_.some(brand.skus, function (sku: $TSFixMe) {

                    return angular.isUndefinedOrNull(sku.forecast.mkshr);
                })) {
                    return;
                }

                for (var i = 0; i < brand.skus.length; i++) {
                    var sku = brand.skus[i];


                    if (angular.isUndefinedOrNull(sku.forecast.value))
                        sku.forecast.value = {
                            pmForecast: [],
                            statisticalForecast: []
                        };

                    mkrshCalculatorService.multiplieByMksrh(
                        sku.forecast.mkshr,
                        brand.forecast.value.pmForecast,
                        brand.forecast.value.statisticalForecast,
                        sku.forecast.value.pmForecast,
                        sku.forecast.value.statisticalForecast);

                }
                return synchronousEventsBus.$broadcast('skuValueForecastChanged', { brand: brand, parameters: parameters });
            }

            service.calculateSkuDotThroughMkshr = function (brand: $TSFixMe, parameters: $TSFixMe) {
                
                if (_.some(brand.skus, function (sku: $TSFixMe) {

                    return angular.isUndefinedOrNull(sku.forecast.mkshr);
                })) {
                    return;
                }

                for (var i = 0; i < brand.skus.length; i++) {
                    var sku = brand.skus[i];


                    if (angular.isUndefinedOrNull(sku.forecast.dot))
                        sku.forecast.dot = {
                            pmForecast: [],
                            statisticalForecast: []
                        };

                    mkrshCalculatorService.multiplieByMksrh(
                        sku.forecast.mkshr,
                        brand.forecast.dot.pmForecast,
                        brand.forecast.dot.statisticalForecast,
                        sku.forecast.dot.pmForecast,
                        sku.forecast.dot.statisticalForecast);

                }
                return synchronousEventsBus.$broadcast('skuDotForecastChanged', { brand: brand, parameters: parameters });
            }

            service.calculateSkuValueFromVolumeThroughPrice = function (brand: $TSFixMe, parameters: $TSFixMe) {
                for (var i = 0; i < brand.skus.length; i++) {
                    var sku = brand.skus[i];

                    sku.forecast.value = {
                        pmForecast: [],
                        statisticalForecast: []
                    };

                    for (var j = 0; j < sku.forecast.volume.statisticalForecast.length; j++) {
                        var price = sku.forecast.price[j];
                        sku.forecast.value.statisticalForecast[j] = price == null ? null : sku.forecast.volume.statisticalForecast[j] * price;
                        sku.forecast.value.pmForecast[j] = price == null ? null : sku.forecast.volume.pmForecast[j] * price;
                    }
                }

                return synchronousEventsBus.$broadcast('skuValueForecastChanged', { brand: brand, parameters: parameters });
            }

            service.calculateSkuVolumeFromValueThroughPrice = function (brand: $TSFixMe, parameters: $TSFixMe) {
                for (var i = 0; i < brand.skus.length; i++) {
                    var sku = brand.skus[i];

                    sku.forecast.volume = {
                        pmForecast: [],
                        statisticalForecast: []
                    };

                    for (var j = 0; j < sku.forecast.value.statisticalForecast.length; j++) {
                        var price = sku.forecast.price[j];
                        sku.forecast.volume.statisticalForecast[j] = price == null ? null : sku.forecast.value.statisticalForecast[j] / price;
                        sku.forecast.volume.pmForecast[j] = price == null ? null : sku.forecast.value.pmForecast[j] / price;
                    }
                }
                return synchronousEventsBus.$broadcast('skuVolumeForecastChanged', { brand: brand, parameters: parameters });
            }

            service.calculateSkuValueFromDotTroughtPrice = function (brand: $TSFixMe, parameters: $TSFixMe) {
                for (var i = 0; i < brand.skus.length; i++) {
                    var sku = brand.skus[i];

                    sku.forecast.value = {
                        pmForecast: [],
                        statisticalForecast: []
                    };

                    for (var j = 0; j < sku.forecast.dot.statisticalForecast.length; j++) {
                        var price = sku.forecast.price[j];

                        sku.forecast.value.statisticalForecast[j] = price == null ? null : sku.forecast.dot.statisticalForecast[j] * price;
                        sku.forecast.value.pmForecast[j] = price == null ? null : sku.forecast.dot.pmForecast[j] * price;
                    }
                }

                return synchronousEventsBus.$broadcast('skuValueForecastChanged', { brand: brand, parameters: parameters });
            }

            service.calculateSkuVolumeFromDotTroughtDddFact = function (brand: $TSFixMe, parameters: $TSFixMe) {
                for (let i = 0; i < brand.skus.length; i++) {
                    let sku = brand.skus[i];

                    sku.forecast.volume = {
                        pmForecast: [],
                        statisticalForecast: []
                    };

                    for (let j = 0; j < sku.forecast.dot.statisticalForecast.length; j++) {
                        sku.forecast.volume.statisticalForecast[j] = sku.forecast.dot.statisticalForecast[j] / sku.dddFact;
                        sku.forecast.volume.pmForecast[j] = sku.forecast.dot.pmForecast[j] / sku.dddFact;
                    }
                }

                return synchronousEventsBus.$broadcast('skuVolumeForecastChanged', { brand: brand, parameters: parameters });
            }
        }]);

    module.run(['skuCalculationService', function (service: $TSFixMe) {
        service.registerEvents();
    }]);

})(angular.module('topline.services'));